import { AxiosError } from "axios";
import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GET_CORE_KITS_FETCH_KEY, Kit } from "@/shared/core-product-kits";
export interface UpdateProductKit {
  name: string;
  products: {
    id: string;
    quantity: number | string;
    price: number;
  }[];
  enabled?: boolean;
}

const updateKitRequest = async (
  id: string,
  updatedData: Partial<UpdateProductKit>,
) => {
  const response = await fetcher.put(`${API.GESLUB}/kit/${id}`, updatedData);
  return response.data;
};

export const useUpdateKit = () => {
  const queryClient = useQueryClient();

  return useMutation<
    Kit,
    AxiosError,
    { id: string; data: Partial<UpdateProductKit> }
  >({
    mutationFn: ({ id, data }) => updateKitRequest(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CORE_KITS_FETCH_KEY] });
    },
  });
};
